import { render, staticRenderFns } from "./DocCateRootEdit.vue?vue&type=template&id=50f892d8&scoped=true"
import script from "./DocCateRootEdit.vue?vue&type=script&lang=js"
export * from "./DocCateRootEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f892d8",
  null
  
)

export default component.exports